const FEATURE_DEFS = [
  { key: 'account_list', label: '账号管理', desc: '查看和管理账号列表' },
  { key: 'basic_monitor', label: '基础数据监控', desc: '账号在线状态和基础数据' },
  { key: 'advanced_monitor', label: '高级数据监控', desc: '播放流速、作品监控、违规检测' },
  { key: 'single_publish', label: '单平台发布', desc: '单个平台发布内容' },
  { key: 'multi_publish', label: '多平台发布', desc: '批量跨平台发布内容' },
  { key: 'auto_reply', label: '自动回复', desc: '粉丝互动自动回复' },
  { key: 'interaction', label: '粉丝互动', desc: '评论管理、私信回复、话术库、附件管理' },
  { key: 'data_monitor', label: '数据监控', desc: '账号监控、播放流速、作品监控、平台通知、违规作品' },
  { key: 'analytics', label: '数据统计', desc: '多平台数据总览、趋势分析、排行榜' },
  { key: 'proxy_support', label: '代理支持', desc: '使用网络代理隔离浏览器环境' },
  { key: 'team_collaboration', label: '团队协作', desc: '多人同时管理和操作账号' },
  { key: 'api_access', label: 'API 接入', desc: '程序化调用接口，支持自定义脚本、Webhook 通知、数据导出' },
  { key: 'priority_support', label: '优先客服', desc: '工单优先处理，专属客服通道' },
  { key: 'dedicated_fingerprints', label: '专属指纹池', desc: '独立浏览器指纹环境隔离' }
]

function getUserMembershipLevel(user) {
  if (!user) return 'basic'
  return user.membership_level || user.level || 'basic'
}

export function isMembershipActive(user) {
  if (!user) return false
  if (user.role === 'admin') return true
  const expireAt = user.membership_expire || user.expire_at || user.expires_at || user.expire_time || user.valid_until || null
  if (!expireAt) return false
  return new Date(expireAt).getTime() > Date.now()
}

export function checkFeature(user, featureKey, plans) {
  if (!user) return false
  if (user.role === 'admin') return true
  if (!isMembershipActive(user)) return false
  const level = getUserMembershipLevel(user)
  const plan = (plans || []).find(p => p.level === level)
  if (!plan) return featureKey === 'account_list'
  return (plan.features || []).includes(featureKey)
}

export function getDefaultFeaturesForLevel(level) {
  const defaults = {
    basic: ['account_list', 'basic_monitor', 'single_publish'],
    vip: ['account_list', 'basic_monitor', 'advanced_monitor', 'single_publish', 'multi_publish', 'auto_reply', 'interaction', 'data_monitor', 'analytics', 'proxy_support'],
    pro: ['account_list', 'basic_monitor', 'advanced_monitor', 'single_publish', 'multi_publish', 'auto_reply', 'interaction', 'data_monitor', 'analytics', 'proxy_support', 'team_collaboration', 'api_access', 'priority_support', 'dedicated_fingerprints']
  }
  return defaults[level] || ['account_list']
}

export { FEATURE_DEFS }
